import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOurServices } from 'api';



// Async thunk for fetching dashboard data
export const fetchourServiceData = createAsyncThunk(
  'ourService',
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchOurServices();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dashboard data');
    }
  }
);

const ourServiceSlice = createSlice({
  name: 'ourService',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchourServiceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchourServiceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchourServiceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = ourServiceSlice.actions;
export default ourServiceSlice.reducer;
